import moment from "moment";
import {
  AddBox,
  ArrowDownward,
  Check,
  ChevronLeft,
  ChevronRight,
  Clear,
  DeleteOutline,
  Edit,
  FilterList,
  FirstPage,
  LastPage,
  Remove,
  SaveAlt,
  Search,
  ViewColumn,
} from "@material-ui/icons";
import { forwardRef } from "react";
/**
 * Table header configurations for Material-UI tables
 */
export const tableHeads = {
  subscriptions: [
    { field: "userName", title: "Name" },
    { field: "userEmail", title: "Email" },
    { field: "vip", title: "VIP Account" },
    { field: "staffCoach", title: "Staff Coach Sub" },
    { field: "bootcampUser", title: "Bootcamp User" },
    { field: "hasACoach", title: "Associated with a Coach?" },
    { field: "platform", title: "Platform" },
    { field: "plan", title: "Plan" },
    { field: "autoRenewal", title: "Auto Renewal" },
    {
      field: "startDate",
      title: "Start Date",
      render: (rowData) => {
        return moment(String(rowData.startDate), "x").format("MM/DD/YYYY");
      },
      defaultSort: "desc",
    },
    {
      field: "lastUpdated",
      title: "Last Updated",
      render: (rowData) => {
        return moment(String(rowData.lastUpdated), "x").format("MM/DD/YYYY");
      },
    },
    {
      field: "endDate",
      title: "End Date",
      render: (rowData) => {
        return moment(String(rowData.endDate), "x").format("MM/DD/YYYY");
      },
    },
  ],
  subscriptionsEnd: [
    { field: "userName", title: "Name" },
    { field: "userEmail", title: "Email" },
    { field: "platform", title: "Platform" },
    { field: "plan", title: "Plan" },
    { field: "autoRenewal", title: "Auto Renewal" },
    {
      field: "startDate",
      title: "Start Date",
      customSort: (a, b) => new Date(a.startDate) - new Date(b.startDate),
      defaultSort: "desc",
    },
    {
      field: "lastUpdated",
      title: "Last Updated",
      customSort: (a, b) => new Date(a.endDate) - new Date(b.endDate),
    },
    {
      field: "endDate",
      title: "End Date",
      customSort: (a, b) => new Date(a.endDate) - new Date(b.endDate),
    },
  ],
  subscriptionsCanceled: [
    { field: "userName", title: "Name" },
    { field: "userEmail", title: "Email" },
    { field: "vip", title: "VIP Account" },
    { field: "platform", title: "Platform" },
    { field: "plan", title: "Plan" },
    { field: "autoRenewal", title: "Auto Renewal" },
    {
      field: "startDate",
      title: "Start Date",
      customSort: (a, b) => new Date(a.startDate) - new Date(b.startDate),
      defaultSort: "desc",
    },
    {
      field: "lastUpdated",
      title: "Last Updated",
      customSort: (a, b) => new Date(a.endDate) - new Date(b.endDate),
    },
    {
      field: "endDate",
      title: "End Date",
      customSort: (a, b) => new Date(a.endDate) - new Date(b.endDate),
    },
  ],
  trialSubs: [
    { field: "userName", title: "Name", filtering: false },
    { field: "userEmail", title: "Email", filtering: false },
    { field: "platform", title: "Platform", filtering: false },
    { field: "plan", title: "Plan", filtering: false },
    {
      field: "startDate",
      title: "Start Date",
      render: (rowData) => {
        return moment(String(rowData.startDate), "x").format("MM/DD/YYYY");
      },
      defaultSort: "desc",
    },
    {
      field: "endDate",
      title: "End Date",
      filtering: false,
      render: (rowData) => {
        return moment(String(rowData.endDate), "x").format("MM/DD/YYYY");
      },
    },
    {
      field: "lastUpdated",
      title: "Last Updated",
      filtering: false,
      render: (rowData) => {
        return moment(String(rowData.lastUpdated), "x").format("MM/DD/YYYY");
      },
    },
    { field: "status", title: "Status", filtering: false },
    { field: "students", title: "# of Students", filtering: false },
    { field: "sessions", title: "# of Sessions", filtering: false },
    { field: "issues", title: "# of S&M", filtering: false },
  ],
  downgradeUsers: [
    { field: "userName", title: "Name" },
    { field: "userEmail", title: "Email" },
    { field: "vip", title: "VIP Account" },
    {
      field: "startDate",
      title: "Start Date",
      customSort: (a, b) => new Date(a.startDate) - new Date(b.startDate),
      defaultSort: "desc",
    },
    {
      field: "endDate",
      title: "End Date",
      customSort: (a, b) => new Date(a.endDate) - new Date(b.endDate),
    },
    { field: "oldPlan", title: "Old Plan" },
    { field: "currentPlan", title: "Current Plan" },
  ],
  nyCampaign: [
    { field: "userName", title: "Name" },
    { field: "email", title: "Email" },
    { field: "paid", title: "Paid" },
    { field: "typicalMiss", title: "Typical Miss" },
    { field: "shotTrajectory", title: "Shot Trajectory" },
    { field: "sessions", title: "# of Sessions" },
    {
      field: "date",
      title: "Account Created",
      customSort: (a, b) => new Date(a.date) - new Date(b.date),
      defaultSort: "desc",
    },
  ],
  freeAccounts: [
    { field: "userName", title: "Name" },
    { field: "userEmail", title: "Email" },
    { field: "dob", title: "DOB" },
    { field: "coaches", title: "Associated with a Coach?" },
    { field: "sessions", title: "# of Sessions" },
    { field: "certification", title: "Certified" },
    {
      field: "date",
      title: "Account Created",
      customSort: (a, b) => new Date(a.date) - new Date(b.date),
      defaultSort: "desc",
    },
  ],
  paidAccounts: [
    { field: "userName", title: "Name" },
    { field: "userEmail", title: "Email" },
    { field: "dob", title: "DOB" },
    { field: "plan", title: "Plan" },
    { field: "students", title: "# of Students" },
    { field: "sessions", title: "# of Sessions" },
    { field: "certification", title: "Certified" },
    {
      field: "date",
      title: "Account Created",
      customSort: (a, b) => new Date(a.date) - new Date(b.date),
      defaultSort: "desc",
    },
  ],
  staffAccounts: [
    { field: "userEmail", title: "Email" },
    { field: "amount", title: "Annual Price" },
    { field: "status", title: "Status" },
    { field: "onboardingCompleted", title: "Onboarding Completed" },
    { field: "students", title: "Total Students" },
    { field: "freeStudents", title: "# of Free Students" },
    { field: "paidStudents", title: "# of Paid Students" },
    {
      field: "date",
      title: "Account Created",
      customSort: (a, b) => new Date(a.date) - new Date(b.date),
      defaultSort: "desc",
    },
  ],
  invites: [
    { field: "invitee", title: "Invitee" },
    { field: "inviteeName", title: "Invitee Name" },
    { field: "sender", title: "Sender" },
    { field: "role", title: "Role" },
    { field: "status", title: "Status" },
    {
      field: "createdDate",
      title: "Created Date",
      customSort: (a, b) => new Date(a.createdDate) - new Date(b.createdDate),
      defaultSort: "desc",
    },
    {
      field: "expiredDate",
      title: "Expiry Date",
      customSort: (a, b) => new Date(a.expiredDate) - new Date(a.expiredDate),
    },
  ],
  total: [
    { field: "plan", title: "" },
    { field: "elavon", title: "Elavon" },
    { field: "apple", title: "Apple" },
    { field: "android", title: "Android" },
    { field: "stripe", title: "Stripe" },
    { field: "overall", title: "Total" },
  ],
  totalActive: [
    { field: "plan", title: "" },
    { field: "elavon", title: "Elavon" },
    { field: "apple", title: "Apple" },
    { field: "android", title: "Android" },
    { field: "stripe", title: "Stripe" },
    { field: "overall", title: "Total" },
  ],
  totalCanceled: [
    { field: "plan", title: "" },
    { field: "elavon", title: "Elavon" },
    { field: "apple", title: "Apple" },
    { field: "android", title: "Android" },
    { field: "stripe", title: "Stripe" },
    { field: "overall", title: "Total" },
  ],
  totalStudents: [
    { field: "students", title: "" },
    { field: "last24Hours", title: "New in the last 24 Hours" },
    { field: "last7Days", title: "New in the last 7 Days" },
    { field: "lastMonth", title: "New in the last Month" },
    { field: "overall", title: "Overall" },
  ],
  collCount: [
    { field: "collection", title: "Collection" },
    { field: "total", title: "Total" },
    { field: "lastUpdated", title: "Last Updated" },
  ],
};

/**
 * Gets table header configuration by name
 */
export const getTableHeader = (name) => {
  return tableHeads[name];
};

export const tableIcons = {
  ExportCSV: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  ExportPDF: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
  DetailPanel: forwardRef((props, ref) => (
    <ChevronRight {...props} ref={ref} />
  )),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => (
    <ChevronLeft {...props} ref={ref} />
  )),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
};
